module.exports = __webpack_public_path__ + "img/kr-product-final-card2-img3.c92246d.png";